import tooltipster from 'tooltipster';

class Tooltip {
	constructor(elem) {
		this.tooltip = elem;
		this.ww = $(window).width();
	}

	initialize() {
		let isCart = this.tooltip.attr('data-tooltip') == 'cart';
		let trigger = this.ww < 768 ? 'click' : 'hover';
		let theme = isCart
			? 'tooltipster-light tooltipster-cart'
			: 'tooltipster-light';

		this.tooltip.tooltipster({
			theme: theme,
			contentAsHTML: true,
			interactive: true,
			trigger: trigger,
			side: 'bottom',
		});
	}

	// tooltip вызываемый для html контента
	tooltipContent() {
		this.tooltip.tooltipster({
			animation: 'fade',
			delay: 200,
			theme: 'tooltipster-default',
			trigger: 'click',
			side: 'bottom',
		});
	}

	resize() {
		this.ww = $(window).width();
	}
}

export {Tooltip};

$(window).on('load', () => {
	let tooltip = [];
	let tooltipContent = [];

	if ($('[data-tooltip]').length > 0) {
		$('[data-tooltip]').each(function (i) {
			tooltip[i] = new Tooltip($(this));
			tooltip[i].initialize();
		});
	}

	if ($('[data-tooltip-content]').length > 0) {
		$('[data-tooltip-content]').each(function (i) {
			tooltipContent[i] = new Tooltip($(this));
			tooltipContent[i].tooltipContent();
		});
	}

	Window.tooltipster = tooltipster;
});
